export const LANGUAGE = 'en-US';
